export class CEInvestmentTimeEntryMeta {}
